/* eslint-disable react-hooks/exhaustive-deps */
/**
 * B100210 バッチマスタメンテ
 */
import {
  B000223BatchNm,
  B100210Create,
  B100210CreateRequest,
  B100210Delete,
  B100210DeleteRequest,
  B100210Update,
  B100210UpdateRequest,
  catchRestError,
} from "clients/rest";
import {
  msgState,
  SCancelButton,
  SCodeSelect,
  SConfirmDialog,
  SFileButton,
  SFrame,
  SLabel,
  SNormalButton,
  SNumberField,
  SText,
  STextField,
} from "components";
import { getClientMessage } from "messages";
import { getSCode, Mode, PickingMethod, SCode } from "messages/codes";
import { labels } from "messages/labels";
import { B100910 } from "pages";
import { useEffect, useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { mode } from "services/codes";
import { focusState, useFocus } from "states";

// 呼び出し時のプロパティ
type Props = Partial<{
  // 呼び出し元へデータを送る場合に設定する。
  handleSubmit: (data: any) => void;
}>;

// コンポーネントで設定されるフィールドの型を定義する
type Fields = Partial<{
  modeKbn: SCode;
  batchNo: string;
  batchNm: string;
  version: number;
  pickingMethod: SCode;
}>;

// フィールドの初期値を設定する。
const defaultFields: Fields = {
  modeKbn: getSCode(Mode, "0"),
  batchNo: "",
  batchNm: "",
  version: undefined,
  pickingMethod: getSCode(PickingMethod, "1"),
};

const focusId = "B100210";
// 画面ID
const gamenId = "100210";

// B100210 バッチマスタメンテ
export const B100210 = (props: Props) => {
  useFocus(focusId);
  return <Page {...props} />;
};

const Page = (props: Props) => {
  // 状態管理の初期設定
  // フォーム関数
  const methods = useForm<Fields>({
    mode: "onBlur",
    defaultValues: defaultFields,
  });

  // フォーカス設定
  const { focus, register } = useRecoilValue(focusState(focusId));
  // エラー表示
  const setMsg = useSetRecoilState(msgState);
  // 画面遷移
  const navigate = useNavigate();
  // 更新確認ダイアログオープン用
  const [openUpdateConfirm, setOpenUpdateConfirm] = useState(false);
  // 活性設定
  // 新規モードかどうか
  const isShinki = methods.watch("modeKbn")?.value === mode.shinki;
  // 修正モードかどうか
  const isShusei = methods.watch("modeKbn")?.value === mode.shusei;
  // 削除モードかどうか
  const isSakujo = methods.watch("modeKbn")?.value === mode.sakujo;

  // 初期表示イベント
  useEffect(() => {
    focus(1);
  }, []);

  // 登録
  const handleCreate = () => {
    setOpenUpdateConfirm(false);

    const fields = methods.getValues();

    // // 登録するデータの作成
    // const param: B100210CreateRequest = {
    //   batchNo: fields.batchNo!,
    //   batchNm: fields.batchNm!,
    //   pickingMethod: fields.pickingMethod!,
    // };

    // B100210Create(param)
    //   .then(() => {
    //     // フィールドの初期化
    //     methods.reset();
    //     // ↓これがあると完了メッセージが表示される
    //     methods.setValue("haisorouteNo", "");
    //     // 登録完了メッセージ表示
    //     setMsg(getClientMessage("B100210_001"));
    //   })
    //   .catch((reason) => {
    //     catchRestError(reason, navigate, setMsg);
    //   });
  };

  // 更新
  const handleUpdate = () => {
    setOpenUpdateConfirm(false);

    const fields = methods.getValues();

    // // 更新するデータの作成
    // const param: B100210UpdateRequest = {
    //   batchNo: fields.batchNo!,
    //   batchNm: fields.batchNm!,
    //   pickingMethod: fields.pickingMethod!,
    //   version: fields.version!,
    // };

    // B100210Update(param)
    //   .then(() => {
    //     // フィールドの初期化
    //     methods.reset();
    //     // ↓これがあると完了メッセージが表示される
    //     methods.setValue("batchNo", "");
    //     // 更新完了メッセージ表示
    //     setMsg(getClientMessage("B100210_002"));
    //   })
    //   .catch((reason) => {
    //     catchRestError(reason, navigate, setMsg);
    //   });
  };

  // 削除
  const handleDelete = () => {
    setOpenUpdateConfirm(false);

    const fields = methods.getValues();

    // // 削除するデータの作成
    // const param: B100210DeleteRequest = {
    //   batchNo: fields.batchNo!,
    // };

    // B100210Delete(param)
    //   .then(() => {
    //     // フィールドの初期化
    //     methods.reset();
    //     // ↓これがあると完了メッセージが表示される
    //     methods.setValue("batchNo", "");
    //     // 削除完了メッセージ表示
    //     setMsg(getClientMessage("B100210_003"));
    //   })
    //   .catch((reason) => {
    //     catchRestError(reason, navigate, setMsg);
    //   });
  };

  const handleChangeMode = () => {
    // 条件をisSakujoにすると、セレクトボックス切り替え時に即座に値がクリアされない
    if (methods.watch("modeKbn")?.value === mode.sakujo) {
      methods.setValue("batchNm", "");
      methods.setValue("pickingMethod", getSCode(PickingMethod, "1"));
    }
  };

  const handleChangeBatchNo = () => {
    if (isShinki) {
      return;
    } else {
      (async () => {
        // await B100230HaisorouteUsedByB100224(methods, navigate, setMsg);
        // await B000223BatchNm(methods, navigate, setMsg);
      })();
    }
  };

  // レイアウト設定
  return (
    <>
      <FormProvider {...methods}>
        <SFrame
          title="バッチマスタメンテ"
          gridTemplateColumns="9rem 11rem 11rem 5rem 5rem"
        >
          <SText gridColumn="span 4"></SText>
          <SFileButton
            label={labels.buttons.excel}
            align="right"
            {...register(6)}
            dialog={<B100910 gamenId={gamenId} />}
          />
          <SLabel required gridColumn="1">
            モード
          </SLabel>
          <SCodeSelect
            required
            name="modeKbn"
            label="モード"
            options={Mode}
            onChange={() => handleChangeMode()}
            {...register(1)}
          />

          <SLabel required gridColumn="1">
            バッチ番号
          </SLabel>
          <SNumberField
            name="batchNo"
            label="バッチ番号"
            code="true"
            required
            size={6}
            {...register(2)}
            onBlur={() => {
              handleChangeBatchNo();
            }}
          />

          <SLabel gridColumn="1">バッチ名</SLabel>
          <STextField
            name="batchNm"
            label="バッチ名"
            code
            size={20}
            {...register(3)}
            gridColumn="span 2"
            disabled={isSakujo}
          />

          <SText gridColumn="span 6">　</SText>

          <SLabel gridColumn="1" gridRow="6">
            ピッキング方式
          </SLabel>
          <SCodeSelect
            required
            name="pickingMethod"
            label="ピッキング方式"
            options={PickingMethod}
            {...register(4)}
            gridColumn="2"
            gridRow="6"
            disabled={isSakujo}
          />

          {isShinki ? (
            <>
              <SNormalButton
                label={labels.buttons.create}
                align="right"
                gridColumn="5"
                gridRow="7"
                {...register(5)}
                dialog={
                  <SConfirmDialog
                    title={labels.dialog.createMasterTitle}
                    msg={labels.dialog.createConfirm}
                  />
                }
                dialogAction="confirm"
                handleSubmit={handleCreate}
              />
            </>
          ) : (
            <>
              {isShusei ? (
                <>
                  <SNormalButton
                    label={labels.buttons.update}
                    align="right"
                    gridColumn="5"
                    gridRow="7"
                    {...register(5)}
                    dialog={
                      <SConfirmDialog
                        title={labels.dialog.updateMasterTitle}
                        msg={labels.dialog.updateConfirm}
                      />
                    }
                    dialogAction="confirm"
                    handleSubmit={handleUpdate}
                  />
                </>
              ) : (
                <>
                  <SCancelButton
                    label={labels.buttons.delete}
                    align="right"
                    gridColumn="5"
                    gridRow="7"
                    {...register(5)}
                    dialog={
                      <SConfirmDialog
                        title={labels.dialog.deleteMasterTitle}
                        msg={labels.dialog.deleteConfirm}
                      />
                    }
                    dialogAction="confirm"
                    handleSubmit={handleDelete}
                  />
                </>
              )}
            </>
          )}
        </SFrame>
      </FormProvider>
    </>
  );
};
